/*
 * Shop Pay installments banner — screen reader bridge. - Start
 */
(function () {
  'use strict';

  var HOST_SELECTOR = 'shopify-payment-terms';
  var INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, [role="button"], [role="link"]';
  var NON_TEXT_TAGS = { STYLE: true, SCRIPT: true, TEMPLATE: true, NOSCRIPT: true };
  var LABEL_CLASS = 'payment-terms-a11y-text';
  var RETRY_MS = 300;
  var MAX_ATTEMPTS = 20;

  var hostWired = new WeakSet();
  var shadowWired = new WeakSet();

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  // The banner's own "Learn more" control is left out: it stays a focus stop of its own
  // with its own label, and folding it in here would announce a dead link. Stylesheets
  // and anything not currently rendered are left out too.
  function renderedText(host) {
    if (!host.shadowRoot) return '';

    var walker = document.createTreeWalker(host.shadowRoot, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || NON_TEXT_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        if (parent.closest(INTERACTIVE_SELECTOR)) return NodeFilter.FILTER_REJECT;
        if (!parent.getClientRects().length) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var parts = [];
    while (walker.nextNode()) parts.push(walker.currentNode.nodeValue);
    return normalize(parts.join(' '));
  }

  // The installment form is the closest light-DOM element that visually contains the
  // banner, so it can take the focus stop without introducing an invisible one.
  function focusTarget(host) {
    return host.closest('form');
  }

  function labelFor(form) {
    var existing = form.querySelector('.' + LABEL_CLASS);
    if (existing) return existing;

    var label = document.createElement('span');
    label.className = LABEL_CLASS + ' visually-hidden';
    form.insertBefore(label, form.firstChild);
    return label;
  }

  function clear(form) {
    var label = form.querySelector('.' + LABEL_CLASS);
    if (label) label.parentNode.removeChild(label);
    form.removeAttribute('tabindex');
  }

  function sync(host) {
    if (!host.isConnected) return false;

    var form = focusTarget(host);
    if (!form) return false;

    var text = renderedText(host);

    // An empty banner means the selected variant has no installments plan. Take the
    // focus stop back rather than announcing terms that no longer apply.
    if (!text) {
      clear(form);
      return false;
    }

    var label = labelFor(form);
    if (normalize(label.textContent) !== text) label.textContent = text;
    if (form.getAttribute('tabindex') !== '0') form.setAttribute('tabindex', '0');
    return true;
  }

  function attachShadowObserver(host) {
    if (!host.shadowRoot || shadowWired.has(host)) return;

    shadowWired.add(host);
    new MutationObserver(function () {
      sync(host);
    }).observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
  }

  // Shopify builds the banner asynchronously, so keep looking for a short while
  // instead of giving up on the first empty read.
  function poll(host, attempt) {
    if (!host.isConnected) return;

    attachShadowObserver(host);

    // Once there is text, later updates arrive through the observers.
    if (sync(host) || attempt >= MAX_ATTEMPTS) return;
    setTimeout(function () {
      poll(host, attempt + 1);
    }, RETRY_MS);
  }

  function wire(host) {
    if (hostWired.has(host)) return;
    hostWired.add(host);

    new MutationObserver(function () {
      sync(host);
    }).observe(host, { attributes: true, attributeFilter: ['variant-id', 'shopify-meta'] });

    poll(host, 0);
  }

  function scan() {
    var hosts = document.querySelectorAll(HOST_SELECTOR);
    for (var i = 0; i < hosts.length; i++) wire(hosts[i]);
  }

  function start() {
    scan();

    // Catch banners added later: variant re-renders, quick add, lazily loaded sections.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/*
 * Shop Pay installments banner — screen reader bridge. - End
 */